import { API2_HOST } from '@/utils/constants';

import request from './request';
import { IBaseResponse, IResult } from './types/common';

// 获取当前汇率
export const getExchangeRate = (params: { name: string }) => {
  const url = `${API2_HOST}/api/exchange-rate`;
  return new Promise((resolve, reject) => {
    request
      .get<IBaseResponse<IResult>>(url, {
        body: JSON.stringify(params),
        useCache: true,
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error: any) => {
        reject(error.response ? error.response.data : error);
      });
  });
};
